import { useLocation, matchPath } from "react-router-dom";
import SidebarMenuItem from "./item";
//import menuItems, { MenuItem } from "./items";
import { useContext, useState } from "react";
import { mergeMenuItems } from "./helpers";
import { SidebarContext } from "../../../../contexts/SidebarContext";
// import { SubMenuWrapper } from "./components/SubMenuStyles";
import { styled } from "@mui/material/styles";
import { List, Popover } from "@mui/material";

export interface MenuItem {
  link?: string;
  icon?: any;
  badge?: string;
  children?: any[];
  name: string;
  permission: string;
  hidden?: boolean;
}

export const usePopover = () => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const handlePopoverOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };

  return {
    anchorEl,
    open: Boolean(anchorEl),
    handlePopoverOpen,
    handlePopoverClose,
  };
};

const SubMenuWrapper = styled(List)<{ collapsed: boolean }>(
  ({ theme, collapsed }) => `
&.MuiList-root {
  position: relative;
  width: ${collapsed ? "91px" : "220px"};
  padding: ${collapsed ? "41px 19px 41px 13px;" : "8px 12px"}; // keep vertical padding but no horizontal shift
  margin-left: ${collapsed ? "-25px" : "0"};
  margin-bottom: ${collapsed ? "200px" : "20px"};
  font-weight: normal !important;
  transition: width 0.3s ease, padding 0.3s ease, margin 0.3s ease;

  &::before {
    content: '';
    position: absolute;
    top: 0; left: 0; right: 0; bottom: 0;
background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='100' height='320' viewBox='0 0 55 190' fill='none'%3E%3Cpath d='M2.44629 12.1592C7.12636 20.1151 15.668 25 24.8984 25C35.4479 25.0002 43.9998 33.5521 44 44.1016V152.539C43.9999 166.048 33.0484 177 19.5391 177C13.629 177 8.15963 180.128 5.16309 185.222L0 194V8L2.44629 12.1592Z' fill='%231F2B2C'/%3E%3C/svg%3E");    background-repeat: no-repeat;
    background-size: contain;
    background-position: center;
    opacity: ${collapsed ? 1 : 0};
    pointer-events: none;
    z-index: 0; // put SVG behind content
    transition: opacity 0.3s ease;
  }

  .MuiListItem-root {
    display: flex;
    align-items: center;
    padding: ${collapsed ? "16px 10px 3px 6px" : "8px 0"};
    margin-bottom: ${collapsed ? "2px" : "15px"};
    height: 35px;
    position: relative;
    z-index: 1;

    .MuiButton-root {
      display: flex;
      width: 100%;
      justify-content: start;
      font-size: ${collapsed ? theme.typography.pxToRem(14) : theme.typography.pxToRem(15)};
      position: relative;
      cursor: pointer;
      z-index: 1;

      .MuiButton-startIcon {
        font-size: ${collapsed ? 25 : 22}px !important;
        margin-right: ${collapsed ? "0" : "12px"};
        z-index: 1;
         color: ${collapsed ? "rgb(153, 158, 187)" : "rgb(153, 158, 187)"};
      }

      &.Mui-active {
        color: ${collapsed ? "var(--zs-last-breadCrumb)" : "#1ba3afff"};
        .MuiButton-startIcon {
          color: #1ba3afff;
        }
      }
&:hover {
  color: ${collapsed ? "rgba(255, 255, 255, 1)" : "rgba(7, 56, 87, 1)"};
  .MuiButton-startIcon {
    color: ${collapsed ? "rgba(255, 255, 255, 1)" : "rgba(7, 56, 87, 1)"};
  }
}
      }
    }
  }
}

  `
);




export const PopoverWrapper = styled(Popover)(
  ({ theme }) => `
    .MuiPopover-paper {
      padding: ${theme.spacing(1, 2)};
      background: rgba(31, 43, 44, 1);
      color: ${theme.palette.primary.contrastText};
      border-radius: ${theme.general.borderRadius || "4px"};
      box-shadow: ${theme.shadows[5] || "0px 4px 10px rgba(0, 0, 0, 0.2)"};
      min-width: 120px; // Ensure popover is wide enough
      font-size: ${theme.typography.pxToRem(14)};
    }
  `
);

const renderSidebarMenuItems = ({
  items,
  path,
  openMenu,
  setOpenMenu,
  userData,
  isExpanded
}: {
  items: any;
  userData: any;
  path: string;
  openMenu: string[];
  setOpenMenu: Function;
  isExpanded: boolean;
}): JSX.Element => {
  return (
    <SubMenuWrapper key={items.path} collapsed={!isExpanded}>
      {items?.reduce(
        (ev: any, item: any) =>
          reduceChildRoutes({
            ev,
            item,
            path,
            openMenu,
            setOpenMenu,
            userData,
            isExpanded
          }),
        []
      )}
    </SubMenuWrapper>
  );
};



const reduceChildRoutes = ({
  ev,
  path,
  item,
  openMenu,
  setOpenMenu,
  userData,
  isExpanded
}: {
  ev: JSX.Element[];
  userData: any;
  path: string;
  item: MenuItem; 
  openMenu: string[];
  setOpenMenu: Function;
  isExpanded: boolean;
}): Array<JSX.Element> => {
  if (!item.name || item.hidden === true) return ev;

  const key = item.name;
  const exactMatch = item.link
    ? !!matchPath({ path: item.link, end: false }, path)
    : false;

  if (item.children) {
    const partialMatch = item.link
      ? !!matchPath({ path: item.link, end: false }, path)
      : false;

    ev.push(
      <SidebarMenuItem
        key={key}
        active={partialMatch}
        open={partialMatch}
        name={item?.name}
        icon={item?.icon}
        link={item?.link}
        badge={item?.badge}
        openMenu={openMenu}
        setOpenMenu={setOpenMenu}
        menus={item}
        hideText={!isExpanded}
      >
        {renderSidebarMenuItems({
          path,
          items: item.children,
          openMenu,
          userData,
          setOpenMenu,
          isExpanded
        })}
      </SidebarMenuItem>
    );
  } else {
    ev.push(
      <SidebarMenuItem
        key={key}
        active={exactMatch}
        name={item?.name}
        link={item?.link}
        badge={item?.badge}
        icon={item?.icon}
        openMenu={openMenu}
        setOpenMenu={setOpenMenu}
        menus={item}
        hideText={!isExpanded}
      />
    );
  }

  return ev;
};


function SidebarMenu(props: any) {
  const location = useLocation();
  const [openMenu, setOpenMenu] = useState<any>([]);
  const { routes } = useContext(SidebarContext);
  const sideMenuItems = mergeMenuItems(routes, true);

  const isExpanded = props.sidebarToggle;

  return (
    <>
      {sideMenuItems.map((menuItem: any, index: any) => (
        <span key={index}>
          {renderSidebarMenuItems({
            items: menuItem.items,
            path: location.pathname,
            openMenu,
            setOpenMenu,
            userData: props?.userData,
            isExpanded,
          })}
        </span>
      ))}
    </>
  );
}

export default SidebarMenu;

